import React, { FC } from "react";
import styles from "./LayoutHeader.module.scss";
import { ActiveLevelIcon } from "@features/common/SvgIcons";
import { useAppSelector } from "@redux/hooks";

interface HeaderTab {
  key: string;
  label: string;
  icon?: React.ReactNode;
}

interface LayoutHeaderProps {
  headerTitle?: string;
  currency?: string;
  amount?: number;
  subHeader?: string;

  tabs?: HeaderTab[];
  activeTabKey?: string;
  onTabChange?: (key: string) => void;
}

const LayoutHeader: FC<LayoutHeaderProps> = ({
  headerTitle,
  currency,
  amount,
  subHeader,
  tabs,
  activeTabKey,
  onTabChange,
}) => {
  const ShowAvailableBalance = useAppSelector(
    (state) => state.common.showAvailableBalance,
  );

  return (
    <div className={styles["header"]}>
      {/* Page Title */}
      <div className={subHeader && styles["sub-header"]}>
        <div className={styles["header__title"]}>
          {headerTitle || "Issue Credits"}
        </div>
        {subHeader && (
          <div className={styles["sub-header__count"]}>{subHeader}</div>
        )}
      </div>
      <div className={styles["right-header"]}>
        {tabs && tabs?.length > 0 && (
          <div className={styles["tab-container"]}>
            {tabs.map((tab) => {
              const isActive = activeTabKey === tab.key;
              return (
                <div
                  key={tab.key}
                  className={
                    styles[
                      `tab-container__tab${
                        activeTabKey === tab.key ? "--active" : ""
                      }`
                    ]
                  }
                  onClick={() => onTabChange?.(tab?.key ?? "")}
                >
                  <div className={styles["tab-container__tab__icon"]}>
                    {tab.icon}
                  </div>
                  <div className={styles["tab-container__tab__text"]}>
                    {tab.label}
                  </div>
                  {isActive && (
                    <div className={styles["tab-container__tab__active-icon"]}>
                      <ActiveLevelIcon />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}

        {/* Available Balance Section */}
        {ShowAvailableBalance && (
          <div className={styles["header__balanceContainer"]}>
            <div className={styles["header__balanceContainer__balanceText"]}>
              {/* Wallet Icon */}
              <img
                src="/images/issue-credits-wallet.svg"
                alt="Wallet"
                className={
                  styles["header__balanceContainer__balanceText__walletIcon"]
                }
              />
              {/* Balance Text */}
              Available Balance {currency ? currency : "AED"}{" "}
              {amount?.toLocaleString() || "0"}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LayoutHeader;
